import { defineMessages } from "react-intl";

export const errorMessagesIntl = defineMessages({
  badRequest: {
    id: "app.error.badRequest",
    defaultMessage: "Please review the highlighted fields and try again.",
  },
  conflict: {
    id: "app.error.conflict",
    defaultMessage:
      "This item already exists or is in use. Please review your changes and try again.",
  },
  databaseTimedOut: {
    id: "app.error.databaseTimedOut",
    defaultMessage: "The database request timed out. Please try again later.",
  },
  databaseUnavailable: {
    id: "app.error.databaseUnavailable",
    defaultMessage:
      "The database service is temporarily unavailable. Please try again later.",
  },
  fetchError: {
    id: "app.error.fetch",
    defaultMessage: "Please check your internet connection.",
  },
  fileTooLarge: {
    id: "app.error.fileTooLarge",
    defaultMessage:
      "The uploaded file is too large. Please reduce the file size and try again.",
  },
  notFound: {
    id: "app.error.notFound",
    defaultMessage: "The requested item was not found.",
  },
  permissionDenied: {
    id: "app.error.permissionDenied",
    defaultMessage: "You do not have permission to perform this action.",
  },
  requestTimeout: {
    id: "app.error.requestTimeout",
    defaultMessage: "The request timed out. Please try again.",
  },
  sessionExpired: {
    id: "app.error.sessionExpired",
    defaultMessage: "Session expired, please login again.",
  },
  tooManyRequests: {
    id: "app.error.tooManyRequests",
    defaultMessage: "Too many requests. Please try again shortly.",
  },
  generic: {
    id: "app.error.generic",
    defaultMessage: "Something went wrong. Please try again later.",
  },
  recordAlreadyExists: {
    id: "app.error.recordAlreadyExists",
    defaultMessage: "This record already exists.",
  },
  recordInUse: {
    id: "app.error.recordInUse",
    defaultMessage:
      "This item is already in use. Please review your changes and try again.",
  },
  recordNotFound: {
    id: "app.error.recordNotFound",
    defaultMessage: "The requested item was not found.",
  },
  valueTooLong: {
    id: "app.error.valueTooLong",
    defaultMessage:
      "One of the values is too long. Please shorten it and try again.",
  },
});
